import React, { useMemo, useState } from 'react';

export default function useMemoWithPrevious<T>(
  memoFn: () => T,
  deps: React.DependencyList,
  shouldUseNewValueCondition: (oldValue: T, newValue: T) => boolean,
  defaultValue: T,
) {
  const [previousData, setPreviousData] = useState<T>(defaultValue);
  const newData = useMemo(() => {
    let calculatedData = memoFn();
    let updatedData = shouldUseNewValueCondition(previousData, calculatedData)
      ? calculatedData
      : previousData;
    setPreviousData(updatedData);
    return updatedData;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps]);

  return newData;
}
